export default ({ float, n, truncateZeroes = false }) => {
  const [left, right] = float.toPrecision(5).split('.');
  if (!right) {
    return left
  } else {
    const newRight = right.slice(0, n);
    if (truncateZeroes && newRight.split('').every(char => char === '0')) {
      return left
    }
    return [left, newRight].join('.');
  }
}
